import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ImportJobDetailView } from "./components/EligibilityImportViews";
import { PATIENT_IMPORT_JOB_TYPES, useImportJobDetail } from "./ImportJobs";

function EligibilityImportJobDetail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { jobId } = useParams();
  const detail = useImportJobDetail(jobId, {
    enabled: true,
    type: PATIENT_IMPORT_JOB_TYPES.CHECK_ELIGIBILITY,
    issuesFileName: (id) => `eligibility-import-issues-${id}.xlsx`,
  });

  return (
    <div className="eligibility_container">
      <div className="flex items-center gap-1 mb-2">
        <IconButton size="small" aria-label={t("Back")} onClick={() => navigate("/eligibility/import-jobs")} sx={{ color: "#2441c9" }}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <span className="font-semibold text-black/70 text-lg">{t("Import Job Details")}</span>
      </div>

      <div className="rounded-lg border border-slate-200 bg-white p-3">
        <ImportJobDetailView jobId={jobId} detail={detail} />
      </div>
    </div>
  );
}

export default EligibilityImportJobDetail;
